import * as React from 'react'

import { BlockerAction } from '@cash-web/protos/squareup/franklin/blocker_action.pb'
import { FormBlocker } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

export interface FormBlockerContextProps {
  blocker: FormBlocker
  onFormBlockerAction: (action: BlockerAction) => Promise<void>
}

export const FormBlockerContext = React.createContext<FormBlockerContextProps>({
  blocker: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFormBlockerAction: () => Promise.resolve(),
})
